export default {
    getHeaderFields: state => state.headerFields,
    getFormActions: state => state.formActions,
    getRowActions: state => state.rowActions,
    getActions: state => state.actions,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,
    getDataTableOptions: state => state.dataTableOptions,
}
